import React, { useCallback } from 'react';

import { CurtainSingleButton, CurtainStatePanel } from 'app/home/main-pages/devices/Devices';
import { CurtainState } from 'app/model/Device';

import './All.scss'

export default function CurtainControl({ device, darkerBorder }) {
    const onClickHV = useCallback((key, value) => {
        return (event) => {
            event.preventDefault();
            let changeStateObject = {}
            changeStateObject[key] = value
            device.changeState(changeStateObject);
        }
    }, [device]);

    const containerClass = device.active ?
        "device-detail-control with-flex curtain-active" : "device-detail-control with-flex curtain-inactive";

    if (device.num_channels === 1) {
        return (
            <div className={containerClass}>
                <div className={"curtain-control-box " + (darkerBorder ? "darker " : "")}>
                    <CurtainSingleButton channel={1} open={true} buttonOrder={1}
                        onClickH={onClickHV("channel1", CurtainState.open)}
                        showStates={true} />
                    <CurtainSingleButton channel={1} open={false} buttonOrder={2}
                        onClickH={onClickHV("channel1", CurtainState.close)}
                        showStates={true} />

                    <CurtainStatePanel
                        side="full" channel={1}
                        state={device.channel1}
                        onClickH={onClickHV("channel1", CurtainState.idle)}
                        waitingForChangeState={device.waitingForChangeState["channel1"]} />
                </div>
            </div>

        )
    } else if (device.num_channels === 2) {
        return (
            <div className={containerClass}>
                <div className={"curtain-control-box " + (darkerBorder ? "darker " : "")}>
                    <CurtainSingleButton channel={1} open={true} buttonOrder={1}
                        onClickH={onClickHV("channel1", CurtainState.open)}
                        showStates={true} />
                    <CurtainSingleButton channel={1} open={false} buttonOrder={2}
                        onClickH={onClickHV("channel1", CurtainState.close)}
                        showStates={true} />

                    <CurtainStatePanel
                        side="full" channel={1}
                        state={device.channel1}
                        onClickH={onClickHV("channel1", CurtainState.idle)}
                        waitingForChangeState={device.waitingForChangeState["channel1"]} />
                </div>
                <div className={"curtain-control-box " + (darkerBorder ? "darker " : "")}>
                    <CurtainSingleButton channel={2} open={true} buttonOrder={1}
                        onClickH={onClickHV("channel2", CurtainState.open)}
                        showStates={true} />
                    <CurtainSingleButton channel={2} open={false} buttonOrder={2}
                        onClickH={onClickHV("channel2", CurtainState.close)}
                        showStates={true} />

                    <CurtainStatePanel
                        side="full" channel={2}
                        state={device.channel2}
                        onClickH={onClickHV("channel2", CurtainState.idle)}
                        waitingForChangeState={device.waitingForChangeState["channel2"]} />
                </div>
            </div>
        )
    } else {
        return null;
    }
}